import React from "react";
import "./Strolls.scss";
import ButtonExit from "../ButtonExit/ButtonExit";

export const Strolls = () => {
  return (
    <section className="strolls">
      <h4 className="strolls__title-ways">
        Проведите время с семьей, близкими или друзьями в окружении
        безмятежности. Организуем командные сплавы (до 10 человек) доступные
        маршруты обсуждаются с организаторами индивидуально Скидка 500руб
        каждому, кто захочет ближе познакомится с командой, помочь в подготовке
        к перевозке SUP и после прогулки поделиться впечатлениями с
        организаторами (либо можешь заменить на отзывы) – это будет очень
        полезно в будущем.
      </h4>

      <ButtonExit />
    </section>
  );
};
